import type { Locale } from 'i18n/localePath';
import { withLocalePrefix } from 'i18n/localePath';
import en from 'i18n/messages/en';
import nl from 'i18n/messages/nl';

import { APP_STORE_URL, PLAY_STORE_URL, getSiteOrigin } from './site';

const JSON_LD_COPY = { en: en.jsonLd, nl: nl.jsonLd };

/**
 * @param opts - ogImageUrl for schema.org image/screenshot
 * @returns schema.org graph for the marketing homepage
 */
export default function buildHomeJsonLd({
  ogImageUrl,
  locale,
}: {
  ogImageUrl: string;
  locale: Locale;
}): Record<string, unknown> {
  const origin = getSiteOrigin();
  const homePath = withLocalePrefix(locale, '/');
  const homeUrl = `${origin}${homePath === '/' ? '/' : homePath}`;
  const copy = JSON_LD_COPY[locale];
  const orgId = `${origin}/#organization`;
  const siteId = `${origin}/#website`;
  const langTag = locale === 'nl' ? 'nl' : 'en';

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': orgId,
        name: 'GastroBuddy',
        url: homeUrl,
        description: copy.orgDescription,
        logo: {
          '@type': 'ImageObject',
          url: ogImageUrl,
        },
        sameAs: [APP_STORE_URL, PLAY_STORE_URL],
      },
      {
        '@type': 'WebSite',
        '@id': siteId,
        url: homeUrl,
        name: 'GastroBuddy',
        description: copy.siteDescription,
        publisher: { '@id': orgId },
        inLanguage: langTag,
      },
      {
        '@type': 'SoftwareApplication',
        name: 'GastroBuddy',
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'iOS, Android',
        offers: {
          '@type': 'Offer',
          price: '0',
          priceCurrency: 'EUR',
          description: 'Free trial period; subscription for full modules.',
        },
        downloadUrl: [APP_STORE_URL, PLAY_STORE_URL],
        screenshot: ogImageUrl,
      },
    ],
  };
}



// WEBPACK FOOTER //
// ./src/seo/jsonLd.ts